import React from "react";
import { Link } from "react-router-dom";
import "./Project.css";

const projects = [
  {
    title: "SR 167, I-5 to SR 509",
    
    img: `${process.env.PUBLIC_URL}/atinkson.jpg`,
   
    location: "Washington State, United States",
    type: "Highway Infrastructure",
    tags: ["Roadwork", "Drainage", "Stream Mitigation", "Geosynthetic Walls", "Box Culverts"],
    owner: "WSDOT",
    contractor: "Atkinson Construction",
    scope:
      "Roadwork, underground drainage, stream mitigation, geosynthetic walls, installation of box culverts, and stream diversion."
  },
  {
    title: "SR 20 Olson Creek Bridge",

    img: `${process.env.PUBLIC_URL}/atinksonone.jpg`,
  
    location: "Washington State, United States",
    type: "Bridge Construction",
    tags: ["Bridge Installation", "Box Culvert", "Weekend Closure", "Accelerated Construction"],
    owner: "WSDOT",
    contractor: "Atkinson Construction",
    scope: "Set voided slab bridge and install box culvert over a weekend closure."
  }
];

const Project = () => {
  return (
    <section className="projects-section" id="projects">
      <div className="proj-container">
        <div className="proj-header">
          <p className="proj-eyebrow">RECENT BUILDS</p>
          <h1 className="proj-title">Engineering Excellence</h1>
          <p className="proj-sub">
            Showcasing our latest infrastructure and construction achievements across Washington State
          </p>
        </div>

        <div className="proj-grid">
          {projects.map((project, idx) => (
            <article key={idx} className="proj-card">
              <div className="proj-card-badge">{project.type}</div>

              <div className="proj-card-head">
                <div className="proj-card-head-inner">
                  <h3 className="proj-card-name">{project.title}</h3>
                
                
                </div>
              </div>

              <figure className="proj-figure">
                <img src={project.img} alt={project.title} className="proj-img" loading="lazy" />
                <div className="proj-img-overlay"></div>
             
              </figure>

              <p className="proj-desc">{project.description}</p>

              <div className="proj-client-info">
                <div className="proj-client-item">
                  <span className="proj-client-label">Owner:</span>
                  <span className="proj-client-value">{project.owner}</span>
                </div>
                <div className="proj-client-item">
                  <span className="proj-client-label">Contractor:</span>
                  <span className="proj-client-value">{project.contractor}</span>
                </div>
              </div>

              <div className="proj-scope">
                <h4 className="proj-scope-title">Project Scope</h4>
                <p className="proj-scope-desc">{project.scope}</p>
              </div>

              <div className="proj-tags">
                {project.tags.map((tag, i) => (
                  <span key={i} className="proj-tag">
                    {tag}
                  </span>
                ))}
              </div>

              <div className="proj-meta">
                <div className="proj-chip">
                  <span className="proj-chip-label">Location</span>
                  <span className="proj-chip-value">{project.location}</span>
                </div>
                <div className="proj-chip">
                  <span className="proj-chip-label">Project Type</span>
                  <span className="proj-chip-value">{project.type}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="proj-cta">
          <Link to="/Projects" className="proj-view-all" aria-label="View all projects in gallery">
            <span>View Project's</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M6 12L10 8L6 4"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Project;